import { AfterViewChecked, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { HighlightService } from 'src/app/core/services/highligh.service';
import { Title } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';

const cdnUrl: string = environment.cdnUrl;

const defaults = {
  'css_cdn':
    `<!-- css BDC -->
<link href="` + cdnUrl + `all.css" rel="stylesheet">`,
  'utils.js':
    `<!-- utils.js BDC -->
<script src="` + cdnUrl + `script.js"></script>`,
  'css_bootstrap':
    `<!-- css bootstrap -->
<link href="https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.min.css"
integrity="sha384-EVSTQN3/azprG1Anm3QDgpJLIm9Nao0Yz1ztcQTwFspd3yD65VohhpuuCOmLASjC"
rel="stylesheet" crossorigin="anonymous">`,
  'js_bootstrap':
    `<!-- js bootstrap -->
<script src="https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/js/bootstrap.bundle.min.js"
integrity="sha384-MrcW6ZMFYlzcLA8Nl+NtUVF0sA7MsXsP1UyJoMp4YLEuNSfAP+JcXn/tWtIaxVXM"
crossorigin="anonymous"></script>`
};

@Component({
  selector: 'app-inicio',
  templateUrl: './inicio.component.html',
  styleUrls: ['./inicio.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class InicioComponent implements OnInit, AfterViewChecked {

  highlighted: boolean = false;

  defaults = defaults;
  public urlComponent = "home";
  public fuenteIconografica = environment.fuenteIconografica;

  public content = [
    {
      'id': 'inicio',
      'nombre': 'Inicio'
    },
    {
      'id': 'conoce',
      'nombre': 'Conoce la nueva versión V.4.0'
    },
    {
      'id': 'integra',
      'nombre': '¿Cómo integrarse al Portal Único del Estado Colombiano?'
    },
    {
      'id': 'como-empezar',
      'nombre': '¿Cómo empezar?',
      'subItems': [
        {
          'id': 'instalacion',
          'nombre': 'Instalación'
        },
        {
          'id': 'dependencia',
          'nombre': 'Dependencias'
        }
      ]
    },
    {
      'id': 'ventajas',
      'nombre': 'Ventajas'
    },
    {
      'id': 'kit-herramientas-integracion',
      'nombre': 'Kit de herramientas para integración'
    },
  ];
  constructor(
    private highlightService: HighlightService,
    private titleHeader: Title) {
  }

  ngOnInit(): void {
    this.titleHeader.setTitle("Biblioteca Digital de Componentes de integración - Versión 4");
  }
  /**
   * Highlight blog post when it's ready
   */
  ngAfterViewChecked() {
    if (!this.highlighted) {
      this.highlightService.highlightAll();
      this.highlighted = true;
    }
  }
}
